import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// INTERFACES
import { ICard } from 'interfaces/Card.interface';

export const CardStyled = styled.div<ICard>`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: white;
  color: ${theme.colors.primary.black};
  padding: 24px;
  border: 1px solid ${theme.colors.primary.transparentBorder};
  padding: 40px;
  flex-grow: 1;
  margin: ${(props: any) => (props.hasMarginRight ? '7px 15px 7px 0px' : '7px 0px 7px 0px')};

  & ~ div {
    margin: 7px 7px 7px 0;
  }

  @media (max-width: 1800px) {
    margin: 7px 0px 7px 0;
  }

  @media only screen and (max-width: 1279px) {
    width: 70%;
  }
`;

export const CardTitleStyled = styled.h2`
  font-size: 20px;
  color: initial;
  margin: 0;
`;

export const CardDescriptionStyled = styled.p`
  font-size: 14px;
  color: initial;
  margin-top: 4px;
`;
